import { Paths } from 'services/navigation/paths';

const baseTabs = [
  { label: 'Dashboard', href: Paths.HOME },
  { label: 'Channels', href: Paths.HOME_CHANNELS },
  { label: 'Usage', href: Paths.HOME_USAGE }
];

export const getHomeTabs = ({
  isAdmin,
  hasCalendarIntegration,
  hasDocumentTypesEnabled
}: {
  isAdmin: boolean;
  hasCalendarIntegration: boolean;
  hasDocumentTypesEnabled: boolean;
}) => {
  const documentsTab = hasDocumentTypesEnabled
    ? [{ label: 'Documents', href: Paths.HOME_DOCUMENTS }]
    : [];

  if (hasCalendarIntegration && isAdmin) {
    return [
      { label: 'Dashboard', href: Paths.HOME },
      { label: 'Channels', href: Paths.HOME_CHANNELS },
      { label: 'Team', href: Paths.HOME_TEAM },
      { label: 'Meetings', href: Paths.HOME_CALENDAR_MEETINGS },
      ...documentsTab,
      { label: 'Usage', href: Paths.HOME_USAGE }
    ];
  }

  if (isAdmin) {
    return [
      { label: 'Dashboard', href: Paths.HOME },
      { label: 'Channels', href: Paths.HOME_CHANNELS },
      { label: 'Team', href: Paths.HOME_TEAM },
      ...documentsTab,
      { label: 'Usage', href: Paths.HOME_USAGE }
    ];
  }

  if (hasCalendarIntegration) {
    return [
      { label: 'Dashboard', href: Paths.HOME },
      { label: 'Channels', href: Paths.HOME_CHANNELS },
      { label: 'Meetings', href: Paths.HOME_CALENDAR_MEETINGS },
      { label: 'Usage', href: Paths.HOME_USAGE }
    ];
  }

  return baseTabs;
};
